<template>
    <zen-one :showuserinfo="false" title="Cukai Tanah:: Laporan 8A" :crumbs="crumbs">
        <z-page :title="`RINGKASAN LAPORAN STATUS TERKINI NOTIS 8A (NOTIS PENGEMBALIAN TANAH KEPADA KERAJAAN)`"
            :append-button="true">

            <w-card :loading="loading">
                <table class="table-dashboard" width="100%" loading="loading">
                    <thead>
                        <tr>
                            <td style="border-top: 1px solid black;border-bottom: 1px solid black; ">DAERAH</td>
                            <td style="border-top: 1px solid black;border-bottom: 1px solid black; ">JUMLAH HAKMILIK
                            </td>
                            <td style="border-top: 1px solid black;border-bottom: 1px solid black; ">JUMLAH TUNGGAKAN
                                (RM)</td>
                            <td style="border-top: 1px solid black;border-bottom: 1px solid black; ">JUMLAH HAKMILIK
                                YANG TELAH BAYAR</td>
                            <td style="border-top: 1px solid black;border-bottom: 1px solid black; ">JUMLAH YANG TELAH
                                DIBAYAR (RM)</td>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="w in laporan2A">
                            <td>{{ w.daerah }}</td>
                            <td align="right">{{ w.data.jum_hakmilik }}</td>
                            <td align="right">{{ w.data.jum_Tunggakan }}</td>
                            <td align="right">{{ w.data.jum_Bayar }}</td>
                            <td align="right">{{ w.data.jumlahBayar }}</td>
                        </tr>
                        <tr style="background-color:greenyellow;">
                            <td>JUMLAH</td>
                            <td align="right"><b>{{ this.total.jumlahHakmilik }}</b></td>
                            <td align="right"><b>{{ this.total.jumlahTunggakan }}</b></td>
                            <td align="right"><b>{{ this.total.jumlah_resit }}</b></td>
                            <td align="right"><b>{{ this.total.jumlahBayar }}</b></td>
                        </tr>
                    </tbody>
                </table>
                <br>
                <w-flex column :gap="3">
                    <w-flex class="justify-end">
                        <w-button bg-color="success" :loading="loading" class="align-self-end" @click="printPdf()">
                            <w-icon class=" mr2 "> fal fa-print</w-icon>
                            &nbsp;Cetak
                        </w-button>
                    </w-flex>
                </w-flex>
            </w-card>
        </z-page>
    </zen-one>
</template>

<script>
import moment from "moment";
import ZResource from "@/Modules/z-resource";

export default {
    extends: ZResource,
    components: {

    },
    data() {
        return {
            resourceurl: "cukai-tanah",
            apiBaseUrl: process.env.MIX_API_BASE_URL,
            reload: true,
            loading: false,
            crumbs: [
                { label: this.$page.props.app_name, route: "/sitemap" },
                { label: "Cukai Tanah", route: "/cukai-tanah/dashboard" },
                { label: "Laporan 8A", route: "/cukai-tanah/senarai" },
            ],
            laporan2A: [],
            total: {},

        };
    },
    methods: {
        printPdf() {
            var url1 = `${this.apiBaseUrl}/cukai/laporan8A`;
            window.open(url1, "_blank");
        },
        async dataGet() {
            this.loading = true;
            await axios({
                method: "get",
                url: `${this.apiBaseUrl}/cukai/laporan8ANoPdf`,
                responseType: "json",
            }).then((e) => {
                this.laporan2A = e.data.data;
                this.total = e.data.total;

            });
            this.loading = false;
        },

    },
    mounted() {
        // this.dataJHM();
        this.dataGet();
    },
};
</script>
